import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import { AuthContext } from 'common/libs/AuthZero/Auth';
import AuthorizeView from 'common/components/AuthorizeView/AuthorizeView';
import { CognitoAuthContext } from 'common/libs/Cognito/Auth.web';
import { isCognitoEnabled } from 'common/constants/featureFlag';

function withAuth0Auth(Component) {
  const AuthComp = hoistNonReactStatics(
    props => (
      <AuthContext.Consumer>
        {auth => (
          <AuthorizeView>
            {userPermission => (
              <Component
                {...props}
                auth={auth}
                userPermission={userPermission}
              />
            )}
          </AuthorizeView>
        )}
      </AuthContext.Consumer>
    ),
    Component
  );

  const componentName = Component.displayName || Component.name || 'unknown';
  AuthComp.diplayName = `withAuth(${componentName})`;

  return AuthComp;
}

function withCognitoAuth(Component) {
  const AuthComp = hoistNonReactStatics(
    props => (
      <CognitoAuthContext.Consumer>
        {auth => (
          <AuthorizeView>
            {userPermission => (
              <Component
                {...props}
                auth={auth}
                userPermission={userPermission}
              />
            )}
          </AuthorizeView>
        )}
      </CognitoAuthContext.Consumer>
    ),
    Component
  );

  const componentName = Component.displayName || Component.name || 'unknown';
  AuthComp.diplayName = `withCognitoAuth(${componentName})`;

  return AuthComp;
}

const withAuth = isCognitoEnabled ? withCognitoAuth : withAuth0Auth;

export default withAuth;
